<template lang="pug">
v-card.mb-4(outlined)
  v-card-title Вложения
  v-card-text.d-flex.flex-wrap.mb-2
    template(v-if="selectFolderId")
      v-btn.mt-2(@click="selectFolderId = null" height="150px")
        v-icon mdi-arrow-left
      v-card.pa-4.mb-2.d-flex.ml-5(
        style="overflow-x:auto"
        outlined
      )
        uploader(@upload="uploadFileIntoFolder($event)")
          template(#activator)
            v-btn.mr-4(color="success" height="120px" width="120px")
              .d-flex.flex-column
                v-icon mdi-plus
        Element.mt-5(
          :name="file.original_name || file.name"
          show-actions
          :show-edit="false"
          v-for="file in [...folders[findIndexFolder].images, ...folders[findIndexFolder].documents]"
          :key="file.id"
          :url="file.url"
          @delete="deleteFileIntoFolder(file)"
        )
      v-col(cols="10")
        p.caption
          | Допускается прикрепление текстовых файлов pdf, doc, docx, excel,
          | изображений img, png. Максимальный размер для каждого файла 5 мб
    template(v-else)
      v-btn.mr-4(color="success" @click="folderDialog = true" height="80px" width="80px")
          .d-flex.flex-column
            v-icon mdi-folder-plus-outline
      uploader(@upload="uploadMainFile($event)")
          template(#activator)
            v-btn.mr-4(color="success" height="80px" width="80px")
              .d-flex.flex-column
                v-icon mdi-plus
      div(v-for="folder in folders" @click="selectFolderId = folder.id")
        folder-icon(
          show-actions
          :key="folder.id"
          :name="folder.name"
          @edit="openEditDialog(folder)"
          @delete="deleteFolder(folder.id)"
        )
      Element(
        :show-edit="false"
        show-actions
        v-for="(file, index) in mainFiles"
        :key="index"
        :url="file.url"
        :name="file.original_name || file.name"
        @delete="deleteMainFile(file, index)"
        )
  v-dialog(width="500px" v-model="folderDialog")
    v-card(outlined dark).pa-4
      p.title {{ form.id ? 'Редактирование папки' : 'Создание новой папки' }}
      v-text-field(v-model="form.name" filled label="Введите название новой папки")
      v-btn(color="success" @click="updateFolder").mr-2 Сохранить
      v-btn(@click="folder.name = ''" text) Сбросить

</template>
<script>
import taskServices from '@/services/API/task';
import { isImage } from '@/lib';
import Uploader from '@/components/core/Uploader.vue';
import FolderApi, { CRUDFolders } from '@/services/API/folder';
import FolderIcon from '@/components/icons/Folder.vue';
import Element from '@/components/icons/Element.vue';

const DEFAULT_FORM = {
  name: '',
};

export default {
  components: {
    FolderIcon,
    Element,
    Uploader,
  },
  props: {
    task: { type: [Object, Array], required: true },
    taskId: { type: [Number, String], required: true },
    mainFiles: { type: [Object, Array], required: true },
  },
  data() {
    return {
      folders: [],
      files: [],
      selectFolderId: null,

      folderDialog:false,
      form:{ ...DEFAULT_FORM },
    };
  },
  computed: {
    findIndexFolder(FolderId) {
      const searchFolder = this.folders.find(({ id }) => id === FolderId || id === this.selectFolderId);
      return this.folders.indexOf(searchFolder);
    },
  },
  async created() {
    await this.fetchFolders();
  },
  methods: {
    openEditDialog(folder) {
      this.form = folder;
      this.folderDialog  = true;
    },
    async fetchFolders() {
      try {
        const params = {
          'search[target_id]': this.taskId,
          'expand': 'images,documents',
        };
        const response = await CRUDFolders.getAll(params);
        this.folders = response.data.data;
      } catch (e) {
        this.$toast.error(e.response.data.result_message);
      }
    },
    async uploadMainFile(file) {
      try {
        const params = {
          'images': [],
          'documents': [],
          'name': this.task.name,
          'description': this.task.description,
        };
        if (isImage(file.file_name)) params.images = [file.file_name];
        if (!isImage(file.file_name)) params.documents = [file.file_name];
        await taskServices.manipulateFiles(this.taskId, params);
        this.mainFiles.push(file);
      } catch (e) {
        this.$toast.error(e.response.data.result_message);
      }
    },
    async deleteMainFile(file) {
      this.mainFiles.splice(this.mainFiles.find((val) => val === file), 1);
      try {
        const params = {
          'del_file_names': [file.name],
          'name': this.task.name,
          'description': this.task.description,
        };
        await taskServices.manipulateFiles(this.taskId, params);
      } catch (e) {
        this.$toast.error(e.response.data.result_message);
      }
    },
    async deleteFileIntoFolder(file) {
      try {
        const params = {
          names: [file.name],
        };
        await FolderApi.deleteFile(this.selectFolderId, params);
        this.folders[this.findIndexFolder].images = this.folders[this.findIndexFolder].images.filter(({ name }) => name !== file.name);
        this.folders[this.findIndexFolder].documents = this.folders[this.findIndexFolder].documents.filter(({ name }) => name !== file.name);
      } catch (e) {
        this.$toast.error(e.response.data.result_message);
      }
    },
    async deleteFolder(id) {
      try {
        await CRUDFolders.delete(id);
        await this.fetchFolders();
      } catch (e) {
        this.$toast.error(e.response.data.result_message);
      }
    },
    async uploadFileIntoFolder(file) {
      let params = {};
      try {
        if (isImage(file.file_name)) params = { images: [file.file_name] };
        if (!isImage(file.file_name)) params = { documents: [file.file_name] };
        FolderApi.addFiles(this.selectFolderId, params);
        if (isImage(file.file_name)) {
          this.folders[this.findIndexFolder].images.push({ url: file.url, name: file.file_name });
        } else {
          this.folders[this.findIndexFolder].documents.push({ url: file.url, name: file.file_name });
        }
      } catch (e) {
        this.$toast.error(e.response.data.result_message);
      }
    },
    async updateFolder() {
      try {
        const params = {
          'target_id': this.taskId,
          'type': 1,
          'name': this.form.name,
        };

        if (this.form.id) {
          await CRUDFolders.update(this.form.id, params);
        } else {
          const response = await CRUDFolders.create(params);
          this.folders.push(response.data.data);
        }
        this.form = { ...DEFAULT_FORM };
        this.folderDialog = false;
        await this.fetchFolders();
      } catch (e) {
        this.$toast.error(e.response.data.result_message);
      }
    },
  },
};
</script>
